import styled from "styled-components"

export const InfoColumnContainer = styled.div `
    padding: 20px;
    width: 33%;
    height: 100%;
    display: flex;
    flex-direction:column;
    align-items: center;
    justify-content: space-around;
    font-size: 1.5rem;
`




